export default __webpack_public_path__ + "static/media/BCBackgroundMobile.86256198.svg";